export const MARKER_ZINDEX = 1998;
export const MARKER_HOVERED_ZINDEX = 1999;
